import type { CustomIconProps } from '../types';

const NavigationArrowRight = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '6'}
        height={height ?? '12'}
        viewBox="0 0 6 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.133421 0.135181C0.311315 -0.0450605 0.599738 -0.0450605 0.777632 0.135181L5.59974 5.02093C6.13342 5.56165 6.13342 6.43835 5.59974 6.97907L0.777632 11.8648C0.599738 12.0451 0.311315 12.0451 0.133421 11.8648C-0.0444735 11.6846 -0.0444735 11.3923 0.133421 11.2121L4.95553 6.32636C5.13342 6.14612 5.13342 5.85389 4.95553 5.67364L0.133421 0.787895C-0.0444735 0.607653 -0.0444735 0.315423 0.133421 0.135181Z"
            fill="#414042"
        />
    </svg>
);

export default NavigationArrowRight;
